import Select from 'react-select/creatable'
import { useDispatch, useSelector } from 'react-redux'
import { FancyToggle } from 'apps/builder/components/settings/modal'
import { FieldSelector } from 'apps/builder/components/shared'
import { updateEntry } from 'apps/builder/store/actions/entries'
import { editSheet } from 'apps/builder/store/actions/sheets'
import { useState } from 'react'
import { Input, RangeInput } from 'components/Input/Input'
import {
  validateWholeInteger,
  validateFieldMask,
} from 'apps/builder/lib/input-validation'
import {
  validateMinRange,
  validateMaxRange,
  eligibleForReferenceData,
} from 'apps/builder/lib/utils'
import {
  FancyRadio,
  FancyCheckbox,
  InlineTooltip,
} from 'apps/builder/components/settings/modal'
import { selectStyles } from 'apps/builder/components/shared'
import {
  builderTypeSelector,
  projectSupportSelector,
  activeSheetSelector,
  activeEntrySelector,
} from 'apps/builder/store/selectors'
import { isLoopScreen } from 'apps/builder/components/workspace/sheets/helpers'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'
import { WhiteLabelCheck } from 'apps/builder/components/shared'
import { lib } from '@gocanvas/client'
const {
  SINGLE_PHOTO_ORIGINAL_TYPE_ID,
  TILE_PHOTO_ENTRY_LABEL_LENGTH,
  DRAWING_ORIGINAL_TYPE_ID,
  SIGNATURE_ORIGINAL_TYPE_ID,
} = lib 


export const MinMaxRange = ({ guid, minimum, maximum }) => {
  const [minValid, validateMin] = useState({ valid: true, errorType: '' })
  const [maxValid, validateMax] = useState({ valid: true, errorType: '' })

  const dispatch = useDispatch()

  const updateMinMaxValue = ({ type, value }) => {
    dispatch(
      updateEntry({
        guid,
        [type]: value,
      })
    )
  }

  const checkMin = value => {
    return maximum ? validateMinRange(value, maximum) : true
  }

  const checkMax = value => {
    return minimum ? validateMaxRange(value, minimum) : true
  }
  const updateValue = (value, type) => {
    //allow only numbers if valid number
    const isValidNumber = validateWholeInteger(value)
    const isValid = type === 'minimum' ? checkMin(value) : checkMax(value)
    const updateMethod = type === 'minimum' ? validateMin : validateMax

    if (!isValidNumber) {
      validateMin({ valid: false, errorType: 'char' })
      return updateMinMaxValue('')
    }

    if (!isValid) {
      updateMethod({ valid: false, errorType: 'num' })
    } else {
      updateMethod({ valid: true, errorType: '' })
    }

    updateMinMaxValue({ type, value: value })
  }

  return (
    <div className="minmax--range--wrapper">
      <RangeInput
        id={`min-${guid}`}
        label={'Minimum'}
        value={minimum}
        error={!minValid.valid}
        errorType={minValid.errorType}
        additionalErrorClass={`min--error`}
        update={value => updateValue(value, 'minimum')}
      />
      <div className="faux--range--line"></div>
      <RangeInput
        id={`max-${guid}`}
        label={'Maximum'}
        additionalErrorClass={`max--error`}
        value={maximum}
        error={!maxValid.valid}
        errorType={maxValid.errorType}
        update={value => updateValue(value, 'maximum')}
      />
    </div>
  )
}

export const NumberFieldStyleOptions = ({
  guid,
  selected,
  default: defaultNumber = '',
  keyField,
}) => {
  const radioProps = {
    guid,
    selected,
    defaultNumber,
    keyField,
  }
  return (
    <>
      <NumberRadio {...radioProps} />
      <IncrementRadio {...radioProps} />
      <SliderRadio {...radioProps} />
      <CurrencyRadio {...radioProps} />
    </>
  )
}

const NumberRadio = ({ guid, selected, default: defaultNumber, keyField }) => {
  const dispatch = useDispatch()
  return (
    <FancyRadio
      id={`${guid}-1`}
      label={'Number'}
      selected={selected}
      value={'Number'}
      onChange={(checked, value) => {
        checked
          ? (() => {
              dispatch(
                updateEntry({
                  guid,
                  style: 0,
                  type: 'Number',
                  description: 'Number',
                  entry_type_id: 12,
                  mask: "0",
                })
              )
            })()
          : ''
      }}
    />
  )
}
export const CurrencyRadio = ({
  guid,
  selected,
  default: defaultNumber,
  keyField,
}) => {
  const dispatch = useDispatch()
  return (
    <FancyRadio
      id={`${guid}-2`}
      label={'Currency'}
      selected={selected}
      disabled={keyField}
      tooltip={keyField && `This style isn’t available for key fields.`}
      value={'Currency'}
      onChange={(checked, value) => {
        checked
          ? (() => {
              dispatch(
                updateEntry({
                  guid,
                  style: 4,
                  description: 'Currency',
                  entry_type_id: 12,
                  mask: "2",
                })
              )
            })()
          : ''
      }}
    />
  )
}

const IncrementRadio = ({
  guid,
  selected,
  default: defaultNumber,
  keyField,
}) => {
  const dispatch = useDispatch()
  const isValid = validateWholeInteger(defaultNumber)
  return (
    <FancyRadio
      id={`${guid}-3`}
      label={'Increment'}
      selected={selected}
      disabled={keyField}
      tooltip={keyField && `This style isn’t available for key fields.`}
      value={'Increment'}
      onChange={(checked, value) => {
        checked
          ? (() => {
              dispatch(
                updateEntry({
                  guid,
                  style: 1,
                  description: 'Increment',
                  entry_type_id: 11,
                  mask: "0",
                  ...(!isValid ? { default: '' } : ''),
                })
              )
            })()
          : ''
      }}
    />
  )
}

const SliderRadio = ({ guid, selected, default: defaultNumber, keyField }) => {
  const dispatch = useDispatch()
  const isValid = validateWholeInteger(defaultNumber)
  return (
    <FancyRadio
      id={`${guid}-4`}
      label={'Slider'}
      selected={selected}
      disabled={keyField}
      tooltip={keyField && `This style isn’t available for key fields.`}
      value={'Slider'}
      onChange={(checked, value) => {
        checked
          ? (() => {
              dispatch(
                updateEntry({
                  guid,
                  style: 2,
                  description: 'Slider',
                  entry_type_id: 11,
                  mask: "0",
                  ...(!isValid ? { default: '' } : ''),
                })
              )
            })()
          : ''
      }}
    />
  )
}

export const RequiredToggle = ({ guid, active, disabled }) => {
  const dispatch = useDispatch()
  return (
    <FancyToggle
      label="Required"
      id={guid}
      active={active}
      inlineBorderStyle={true}
      disabled={disabled}
      onChange={checked => {
        dispatch(
          updateEntry({
            guid,
            required: checked,
          })
        )
      }}
    />
  )
}

export const DecimalToggle = ({ guid, mask = null }) => {
  const dispatch = useDispatch()
  const isActive = mask === null ? true : false
  return (
    <FancyToggle
      label="Allow Decimals"
      id={guid}
      active={isActive}
      inlineBorderStyle={true}
      onChange={checked => {
        const value = checked ? null : '0'
        dispatch(
          updateEntry({
            guid,
            mask: value,
          })
        )
      }}
    />
  )
}

export const ReadOnlyToggle = ({ guid, active }) => {
  const dispatch = useDispatch()
  return (
    <FancyToggle
      label="Read Only"
      id={guid}
      active={active}
      inlineBorderStyle={true}
      onChange={checked => {
        dispatch(
          updateEntry({
            guid,
            read_only: checked,
          })
        )
      }}
    />
  )
}

export const SettingsFieldSelect = ({ keyField, type, style, label, guid }) => {
  const dispatch = useDispatch()
  const activeSheet = useSelector(activeSheetSelector)
  const { id: sheetId, style: sheetStyle } = activeSheet
  const activeEntry = useSelector(activeEntrySelector)
  const {
    reference_data_id: existingRefDataId,
    reference_data_column: existingRefDataColumn,
    dependent_entry: existingDependentEntry,
  } = activeEntry || {}
  const changeFieldType = ({
    id,
    original_type_id,
    placeholder: newPlaceholder,
    ...type
  }) => {
    // If the entry has reference data, we need to maintain that data if the new entry type is eligible
    let refDataProps = {}
    if (
      (existingRefDataId || existingRefDataColumn) &&
      eligibleForReferenceData(type)
    ) {
      refDataProps = {
        reference_data_id: existingRefDataId,
        reference_data_column: existingRefDataColumn,
        dependent_entry: existingDependentEntry,
      }
    }

    dispatch(
      updateEntry({
        ...type,
        entry_type_id: id,
        original_type_id: original_type_id,
        guid,
        label: label,
        placeholder: newPlaceholder,
        ...refDataProps,
      })
    )
    // if we're on a table sheet w/ style 2 and we change the keyfield from 
    // Dropdown to anything else, we need to change the style to 1
    if (isLoopScreen(activeSheet) && keyField && sheetStyle == 2 && type !== "Dropdown") {
      dispatch(editSheet({ id: sheetId, sheetPayload: { style: 1 } }))
    }
  }

  return (
    <div className="settings--field-type">
      <FieldSelector
        keyField={keyField}
        className="input--placeholder"
        value={{ value: type, label: type, style }}
        onChange={changeFieldType}
        open={false}
      />
      <label>Field Type</label>
    </div>
  )
}

export const SystemDefaultSelect = ({ guid, style }) => {
  const builderType = useSelector(builderTypeSelector)
  const projectSupport = useSelector(projectSupportSelector)
  const dispatch = useDispatch()

  if (builderType === 'web-form') {
    return null
  }

  const buildOptions = () => {
    const systemDefaultOptions = [
      { value: '0', label: 'None' },
      { value: '1', label: 'Username' },
      { value: '2', label: 'Company Name' },
      { value: '3', label: 'First Name' },
      { value: '4', label: 'Last Name' },
      { value: '5', label: 'Full Name (First Last)' },
    ]

    if (projectSupport) {
      return [
        ...systemDefaultOptions,
        {
          value: '20',
          label: 'Customer Code',
        },
        {
          value: '21',
          label: 'Site Code',
        },
        {
          value: '22',
          label: 'Project Code',
        },
      ]
    }

    return systemDefaultOptions
  }

  const options = buildOptions()

  const defaultOption =
    options.find(({ value }) => value === `${style}`) || options[0]

  const isDisabled =
    style && !options.map(({ value }) => value).includes(`${style}`)

  return (
    <div className="system-default--settings label-floating">
      <Select
        styles={selectStyles}
        className="input--placeholder"
        classNamePrefix="react-select"
        options={options}
        value={defaultOption}
        isDisabled={isDisabled}
        onChange={({ value }) => {
          dispatch(
            updateEntry({
              guid,
              style: value,
            })
          )
        }}
      />
      <label>System Default</label>
    </div>
  )
}

const ImageSizeDropdown = ({
  guid,
  style,
  isDisabled,
  original_type_id,
  type,
}) => {
  const dispatch = useDispatch()

  const defaultOptions = [
    {
      value: -1,
      label: 'Smallest',
    },
    {
      value: 0,
      label: 'Thumbnail',
    },
    {
      value: 2,
      label: 'Small',
    },
    {
      value: 3,
      label: 'Medium',
    },
    {
      value: 1,
      label: 'Largest',
    },
  ]

  const signatureOptions = [
    {
      value: -1,
      label: 'Small',
    },
    {
      value: 0,
      label: 'Medium',
    },
    {
      value: 2,
      label: 'Large',
    },
  ]

  const options = original_type_id == SIGNATURE_ORIGINAL_TYPE_ID ? signatureOptions : defaultOptions

  let defaultStyle = style
  if (isNaN(defaultStyle)) {
    switch (original_type_id) {
      case SINGLE_PHOTO_ORIGINAL_TYPE_ID:
        defaultStyle = 0
        break
      case DRAWING_ORIGINAL_TYPE_ID:
        defaultStyle = 1
        break
      case SIGNATURE_ORIGINAL_TYPE_ID:
        defaultStyle = -1
    }
  }

  const selectedValue =
    options.find(({ value }) => value == defaultStyle)

  return (
    <div className="settings--field-type">
      <Select
        styles={selectStyles}
        className="input--placeholder"
        classNamePrefix="react-select"
        isDisabled={isDisabled}
        value={selectedValue}
        options={options}
        onChange={({ value }) => {
          dispatch(
            updateEntry({
              guid,
              style: value,
            })
          )
        }}
      />
      <label>
        {`${type} Size`}
      </label>
    </div>
  )
}

export const StandardPdfSettings = ({
  guid,
  inserts_page_break_at_the_end,
  uses_caption_format,
  label,
  style,
  original_type_id,
  type,
}) => {
  const dispatch = useDispatch()
  const isSinglePhoto = original_type_id == SINGLE_PHOTO_ORIGINAL_TYPE_ID
  const disableTilePhotoOption = label && label.length > TILE_PHOTO_ENTRY_LABEL_LENGTH

  return (
    <>
      <label className="settings--label">Standard PDF</label>
      <div className="settings--field-type">
        <FancyCheckbox
          id={`${guid}--page-break-after`}
          checked={inserts_page_break_at_the_end}
          onChange={() => {
            dispatch(
              updateEntry({
                guid,
                inserts_page_break_at_the_end: !inserts_page_break_at_the_end,
              })
            )
          }}
          label={'Page Break After'}
        />
        {isSinglePhoto && (
          <div className="settings--tile-photo">
            <FancyCheckbox
              id={`${guid}--tile-photo`}
              checked={uses_caption_format}
              disabled={disableTilePhotoOption}
              onChange={() => {
                dispatch(
                  updateEntry({
                    guid,
                    uses_caption_format: !uses_caption_format,
                  })
                )
              }}
              label={'Tile Photo'}
            />
            {disableTilePhotoOption && (
              <InlineTooltip
                tooltip={`Field label for a tile photo has a maximum limit of 30 characters.`}
                icon={faInfoCircle}
                direction="bottom"
              />
            )}
          </div>
        )}
      </div>
      <ImageSizeDropdown
        guid={guid}
        style={style}
        original_type_id={original_type_id}
        type={type}
        isDisabled={isSinglePhoto && uses_caption_format}
      />
    </>
  )
}

export const FieldMaskSetting = ({ guid, mask }) => {
  const dispatch = useDispatch()
  const [fieldMaskError, setFieldMaskError] = useState(false)

  const updateFieldMask = value => {
    const errorMessage = validateFieldMask(value)

    if (!errorMessage) {
      dispatch(
        updateEntry({
          guid,
          mask: value,
        })
      )
    }

    setFieldMaskError(errorMessage)
  }

  return (
    <>
      <div className="tooltip-group">
        <InlineTooltip
          tooltip={
            <>
              {`Field Mask can only contain the following characters: 0, 9, A, a, L, l, ?, *. `}
              <WhiteLabelCheck>
                <div>
                  <a
                    href="https://help.gocanvas.com/hc/en-us/articles/25139091288087-Using-the-Field-Mask-Setting-in-the-Builder"
                    target="blank"
                  >
                    Learn More
                  </a>
                </div>
              </WhiteLabelCheck>
            </>
          }
          icon={faInfoCircle}
          direction={`bottom`}
        />
      </div>
      <div className="checkbox-label">
        <Input
          value={mask}
          placeholder={' '}
          id={`${guid}-field-mask`}
          update={input => updateFieldMask(input)}
          label={'Field Mask'}
          additionalClass={'error-message'}
          maxLength={30}
          error={fieldMaskError}
          errorText={fieldMaskError}
        />
      </div>
    </>
  )
}